export const AUTOCOMPLETE_POPPER_BOX_SHADOW_OPACITY = 0.13;
export const AUTOCOMPLETE_LIST_ITEM_VERTICAL_SPACING = 1;
export const AUTOCOMPLETE_LIST_ITEM_HORIZONTAL_SPACING = 3;

export const AUTOCOMPLETE_QUERY_MIN_LENGTH_TO_REQUEST_SUGGESTIONS_DEFAULT = 3;
